var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5147 6.01855C21.145 6.01855 19.8813 5.5648 18.8664 4.79934C17.7025 3.92184 16.8663 2.63465 16.571 1.15105C16.4969 0.778018 16.458 0.398859 16.4547 0.0185547H12.5421V10.7098L12.5374 16.5659C12.5374 18.1315 11.5178 19.459 10.1046 19.9259C9.68123 20.0659 9.23537 20.125 8.79019 20.1003C8.20144 20.0679 7.64972 19.8903 7.17019 19.6034C6.14972 18.9931 5.45784 17.8859 5.43909 16.6193C5.40956 14.6398 7.00987 13.0259 8.988 13.0259C9.37847 13.0259 9.75347 13.0896 10.1046 13.2054V9.23277C9.73425 9.17793 9.35737 9.14934 8.97628 9.14934C6.81112 9.14934 4.78612 10.0493 3.33862 11.6707C2.24456 12.8961 1.58831 14.4593 1.48706 16.0986C1.3544 18.252 2.14237 20.299 3.6705 21.8093C3.89503 22.0311 4.13081 22.2368 4.37737 22.4267C5.68753 23.435 7.28925 23.9815 8.97628 23.9815C9.35737 23.9815 9.73425 23.9534 10.1046 23.8986C11.6805 23.6651 13.1346 22.9437 14.2821 21.8093C15.6921 20.4157 16.4711 18.5656 16.4796 16.5964L16.4594 7.85137C17.1336 8.37143 17.8723 8.80218 18.6569 9.13293C19.8846 9.6509 21.1863 9.9134 22.526 9.91293V6.01762C22.5269 6.01855 22.5157 6.01855 22.5147 6.01855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.abb1fbe3e3d0a230ccb4d5b4b1d21833.svg";
export { ForwardRef as ReactComponent };